const INTERACTIVE_SELECTOR = [
  '.portal-reaction-button', '.portal-reaction-toggle', '.portal-reaction-icon-button',
  '.portal-comment-toggle', '.portal-comment-button', '.portal-comment-submit-button',
  '.portal-share-toggle', '.portal-share-copy-button', '.job-card-like-button',
  '.jt-job-action-button', '.jt-job-review-button', '.portal-public-menu-toggle',
  '.portal-public-nav-link', '.portal-profile-detail-close', '.portal-comment-modal-close',
  '.jt-modal-close', '.login-modal-close', '.terms-modal-close',
  '[aria-label*="reaction" i]', '[aria-label*="comment" i]', '[aria-label*="share" i]',
  '[aria-label*="close" i]', '[aria-label*="open" i]'
].join(',');

const STRONG_SELECTOR = [
  '.portal-reaction-button', '.portal-reaction-toggle', '.job-card-like-button',
  '.portal-comment-submit-button', '.portal-public-menu-toggle'
].join(',');

export const triggerMobileHaptic = (pattern = 10) => {
  if (typeof window === 'undefined' || !window.matchMedia('(pointer: coarse)').matches) return;
  if (typeof navigator.vibrate === 'function') navigator.vibrate(pattern);
};

export const installMobileInteractionFeedback = () => {
  if (typeof document === 'undefined') return () => {};

  const visualViewport = window.visualViewport;
  const mobileQuery = window.matchMedia('(max-width: 768px) and (hover: none)');

  // Keep the chat canvas equal to the browser's visible viewport. There is no
  // keyboard state or composer offset: the chat simply follows the visible
  // rectangle when Safari pans it for a focused textarea.
  const syncMobileChatViewport = () => {
    if (!mobileQuery.matches) {
      document.documentElement.style.removeProperty('--jt-mobile-chat-height');
      document.documentElement.style.removeProperty('--jt-mobile-chat-top');
      return;
    }

    const visibleHeight = Math.round(visualViewport?.height || window.innerHeight);
    const visibleTop = Math.max(0, Math.round(visualViewport?.offsetTop || 0));
    document.documentElement.style.setProperty('--jt-mobile-chat-height', `${visibleHeight}px`);
    document.documentElement.style.setProperty('--jt-mobile-chat-top', `${visibleTop}px`);
  };

  const handleClick = (event) => {
    const target = event.target?.closest?.(INTERACTIVE_SELECTOR);
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;

    triggerMobileHaptic(target.matches(STRONG_SELECTOR) ? 14 : 8);
    target.classList.remove('jt-mobile-feedback-pulse');
    // Restart the animation even when the same control is tapped repeatedly.
    void target.offsetWidth;
    target.classList.add('jt-mobile-feedback-pulse');
    window.setTimeout(() => target.classList.remove('jt-mobile-feedback-pulse'), 260);
  };

  document.addEventListener('click', handleClick, true);
  syncMobileChatViewport();
  window.addEventListener('resize', syncMobileChatViewport);
  window.addEventListener('orientationchange', syncMobileChatViewport);
  visualViewport?.addEventListener('resize', syncMobileChatViewport);
  visualViewport?.addEventListener('scroll', syncMobileChatViewport);
  mobileQuery.addEventListener?.('change', syncMobileChatViewport);

  return () => {
    document.removeEventListener('click', handleClick, true);
    window.removeEventListener('resize', syncMobileChatViewport);
    window.removeEventListener('orientationchange', syncMobileChatViewport);
    visualViewport?.removeEventListener('resize', syncMobileChatViewport);
    visualViewport?.removeEventListener('scroll', syncMobileChatViewport);
    mobileQuery.removeEventListener?.('change', syncMobileChatViewport);
    document.documentElement.style.removeProperty('--jt-mobile-chat-height');
    document.documentElement.style.removeProperty('--jt-mobile-chat-top');
  };
};
